module.exports = __webpack_public_path__ + "img/autograph.be40cb40.png";